import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ProyectoObjetivoDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ProyectoObjetivoService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getProyectoObjetivoService(): Observable<BodyListResponse<ProyectoObjetivoDTO>> {
    return this.http.get<BodyListResponse<ProyectoObjetivoDTO>>(API_URL + '/api/v1/proyectoObjetivo/todos');
  }

  guardarProyectoObjetivoService(proyectoObjetivoDTO: ProyectoObjetivoDTO): Observable<BodyResponse<ProyectoObjetivoDTO>> {
    return this.http.post<BodyResponse<ProyectoObjetivoDTO>>(API_URL + '/api/v1/proyectoObjetivo', proyectoObjetivoDTO);
  }
  /***********nuevo */

  getProyectoObjetivoPorProyectoService(codigo: any, estado: any): Observable<BodyListResponse<ProyectoObjetivoDTO>> {
    return this.http.get<BodyListResponse<ProyectoObjetivoDTO>>(API_URL + '/api/v1/proyectoObjetivo/proyecto/' + codigo + '/' + estado);
  }


}
